import { render, staticRenderFns } from "./ownersEdit.vue?vue&type=template&id=735025e8"
import script from "./ownersEdit.vue?vue&type=script&lang=js"
export * from "./ownersEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports